(function (doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;

      if(clientWidth >1000 ){
        docEl.style.fontSize = 20 * (clientWidth / 500) + 'px';
      }else {
        docEl.style.fontSize = "13.3333333vw"
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false)
})(document, window)


/*
(function(t, e) {
  var a = t.documentElement, n = navigator.userAgent.match(/iphone|ipod|ipad|android/gi), o = n ? Math.min(e.devicePixelRatio, 3) : 1, i = "orientationchange"in window ? "orientationchange" : "resize";
  a.dataset.dpr = o;
  var r = t.getElementsByTagName("meta"), s = t.getElementsByTagName("head")[0];
  function c() {
    for (var t = 0; t < r.length; t++)
      "viewport" === r[t].getAttribute("name") && s.removeChild(r[t])
  }
  function u() {
    var e = t.createElement("meta");
    e.setAttribute("name", "viewport"),
      e.setAttribute("content", "width=device-width, initial-scale=" + 1 / o + ", maximum-scale=" + 1 / o + ", minimum-scale=" + 1 / o + ", user-scalable=no"),
      s.insertBefore(e, s.children[0])
  }
  c(),
    u();
  var l = function() {
    var t = a.clientWidth;
    t / o > 750 && (t = 750 * o),
      a.style.fontSize = t / 750 * 100 + "px"
  };
  l(),
  t.addEventListener && e.addEventListener(i, l, !1)
})(document, window);
*/



// WEBPACK FOOTER //
// ./src/config/rem.js